import UiKitButton from 'components/ui-kit/Button/Button';
import { useTranslation } from 'react-i18next';

type Props = {
  feedback: string;
  submitting: boolean;
  onSubmit: () => void;
};

const FeedbackActions = ({ feedback, submitting, onSubmit }: Props) => {
  const { t } = useTranslation();

  return feedback.length > 0 ? (
    <UiKitButton buttonType="primary" fullWidth disabled={submitting} onClick={onSubmit}>
      {t('components.feedback.submit')}
    </UiKitButton>
  ) : (
    <UiKitButton buttonType="outlined" fullWidth disabled={submitting} onClick={onSubmit}>
      {t('components.feedback.skip-and-submit')}
    </UiKitButton>
  );
};

export default FeedbackActions;
